import { atom } from "recoil";

export type chatType = {
  visible: boolean;
  cs_id: number | null;
  area_name: string;
  chat_id: number | null;
  date: string;
};

export type chatOrderType = {
  order_id: string;
  order_seq: number;
  store_id: number;
  store_name: string;
};

export type ChatListType = {
  cs_id: number;
  store_id: number;
  order_id: string;
  order_seq: number;
};

export const csChatState = atom<chatType>({
  key: "csChatState",
  default: {
    visible: false,
    cs_id: null,
    chat_id: null,
    area_name: "",
    date: "",
  },
});

export const storeChatState = atom<chatType>({
  key: "storeChatState",
  default: {
    visible: false,
    cs_id: null,
    area_name: "",
    chat_id: null,
    date: "",
  },
});

export const csChatFinishedState = atom<boolean>({
  key: "csChatFinished",
  default: false,
});

export const storeChatFinishedState = atom<boolean>({
  key: "storeChatFinished",
  default: false,
});

export const selectChatState = atom<boolean>({
  key: "selectChat",
  default: false,
});

export const newChatListState = atom<ChatListType[]>({
  key: "newChatList",
  default: [],
});

export const csChatListState = atom<boolean>({
  key: "csChatList",
  default: false,
});
